module.exports = __webpack_public_path__ + "static/media/DSC09823_20180710_079-2.95367813.jpg";